import { PaymentType } from '~/generated/graphql'

/** 立替型キャンペーンを許可する支払い方法（marketing-api と同一） */
export const EXPENSE_CAMPAIGN_ALLOWED_PAYMENT_TYPES: readonly PaymentType[] = [
  PaymentType.CreditCardGmopg,
  PaymentType.Invoice,
]

export const isExpenseCampaignAllowed = (paymentType: PaymentType | null | undefined): boolean => {
  if (paymentType == null) {
    return false
  }
  return EXPENSE_CAMPAIGN_ALLOWED_PAYMENT_TYPES.includes(paymentType)
}
